import React from "react";
import styled from "styled-components";
import { Table as BsTable } from "react-bootstrap";
import { VentaDelMes } from "../../../services/ventasServicios";
import { formatearTiempo } from "../../../utils/dateUtils";
import { currencyFormat } from "../../../utils/numberUtils";
import ConceptosVentaBadges from "../../organisms/ConceptosVentaBadges";
import { useUsuarioActual } from "../../../services/authServicios";
import {
  tieneRol,
} from "../../../services/rolAutorizacion";

function Table({
  items,
  onSeleccionarVenta,
}: {
  items: VentaDelMes[];
  onSeleccionarVenta: (idVenta: string) => void;
}) {
  return (
    <StyledTable responsive hover>
      <thead>
        <tr>
          <StyledColHeader>Fecha</StyledColHeader>
          <StyledColHeader>Mascota</StyledColHeader>
          <StyledColHeader>Propietario</StyledColHeader>
          <StyledColHeader>Conceptos</StyledColHeader>
          <StyledColHeader>Total</StyledColHeader>
          <StyledColHeader>Pendiente</StyledColHeader>
          <StyledColHeader>¿Pagada?</StyledColHeader>
        </tr>
      </thead>
      <tbody>
        {items.map((_, i) => (
          <TableItem
            key={_.id}
            item={_}
            no={i + 1}
            onSeleccionarVenta={onSeleccionarVenta}
          />
        ))}
      </tbody>
    </StyledTable>
  );
}

function TableItem({
  item,
  onSeleccionarVenta,
}: {
  no: number;
  item: VentaDelMes;
  onSeleccionarVenta: (idVenta: string) => void;
}) {
  const { data: usuario } = useUsuarioActual();
  const puedeSeleccionar = tieneRol(usuario?.roles ?? [], "VISUALIZAR_PAGAR_VENTA");

  const onRowClick = () => {
    if (!puedeSeleccionar) return;
    onSeleccionarVenta(item.id);
  };
  return (
    <StyledRow onClick={onRowClick} $clickable={puedeSeleccionar}>
      <StyledCell>{formatearTiempo(new Date(item.fecha))}</StyledCell>
      <StyledCell>{item.mascota}</StyledCell>
      <StyledCell>{item.nombresPropietario}</StyledCell>
      <StyledCell>
        <ConceptosVentaBadges conceptos={item.conceptosVenta} />
      </StyledCell>
      <StyledCell>{currencyFormat(item.total)}</StyledCell>
      <StyledCell>{currencyFormat(item.pendiente)}</StyledCell>
      <StyledCell>{item.pagada ? "Si" : "No"}</StyledCell>
    </StyledRow>
  );
}

const StyledTable = styled(BsTable)``;

const StyledCell = styled("td")``;

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledRow = styled("tr")<{ $clickable?: boolean }>`
  cursor: ${(props) => (props.$clickable ? "pointer" : "default")};
`;

export default Table;
